<template>
    <div class="container-fluid">
        <div class="row">
            <div class="mt-0">
                <div class="row" id="lower-div">
                    <div class="card mt-4">
                        <div class="p-3">
                            <div class="d-flex align-items-center gap-2 mb-3">
                                <button type="button" @click="NewQuota()" class="btn action-btn action-btn--success">
                                    <i class="bi bi-plus-lg me-1"></i>
                                    <span>Yeni ərizə</span>
                                </button>
                                <button type="button" class="btn action-btn action-btn--muted" @click="GetQuotas()">
                                    <i class="bi bi-arrow-clockwise me-1"></i>
                                    <span>Yeniləmək</span>
                                </button>
                                <button
                                    type="button"
                                    @click="this.showFilter = !this.showFilter"
                                    class="btn action-btn"
                                    :class="this.showFilter ? 'action-btn--info' : 'action-btn--muted'"
                                    title="Filter"
                                >
                                    <i class="bi bi-funnel-fill"></i>
                                </button>
                            </div>
                            <transition name="slide">
                                <div class="row my-3" v-show="this.showFilter">
                                    <div class="col-sm-6 col-md-5 col-lg-4">
                                        <div class="app-search-form-group">
                                            <el-input
                                                v-model="srcText"
                                                placeholder="Tam adı / VÖEN"
                                                clearable
                                                class="app-search-input"
                                                @keydown.enter="GetQuotas()"
                                            />
                                            <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                                <i class="bi bi-search"></i>
                                                <span>Axtar</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div v-loading="loading">
                                <Table :data="data.slice((this.page - 1) * 10, this.page * 10)"
                                    :showFilter="showFilter"></Table>
                                <div style="margin-left: 1%; margin-top: 1%;">
                                    <el-pagination :current-page="this.page"
                                        @current-change="(value) => { page = value }" :page-size="10" background
                                        layout="prev, pager, next" :total="this.data.length" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import Table from "./Components/Table.vue";
export default {
    components: {
        Table
    },
    data() {
        return {
            srcText: null,
            loading: null,
            page: 1,
            data: [
                {
                    clientId: 1,
                    companyName: "AzərTech MMC",
                    voen: "2001234561",
                    phone: "+994501112233",
                    email: "info@azertech.az",
                    address: "Bakı, Yasamal r., Tbilisi pr. 45",
                    clientSector: "Neft sektoru",
                    registrationDate: "12.03.2022",
                    created: "12.03.2022 14:20",
                    updated: "05.06.2023 10:15"
                },
                {
                    clientId: 2,
                    companyName: "Qafqaz Logistics",
                    voen: "2109876543",
                    phone: "+994553334455",
                    email: "contact@qafqazlog.az",
                    address: "Sumqayıt, 21-ci mikrorayon",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "01.07.2021",
                    created: "01.07.2021 09:30",
                    updated: "11.09.2023 16:40"
                },
                {
                    clientId: 3,
                    companyName: "Baku Consulting",
                    voen: "2015567890",
                    phone: "+994702225566",
                    email: "office@bakucon.az",
                    address: "Bakı, Nərimanov r., H.Əliyev pr. 120",
                    clientSector: "Müəyyən edilməmiş",
                    registrationDate: "25.11.2020",
                    created: "25.11.2020 12:00",
                    updated: "08.04.2023 18:25"
                },
                {
                    clientId: 4,
                    companyName: "Caspian Energy",
                    voen: "2012345678",
                    phone: "+994503331122",
                    email: "info@caspianenergy.az",
                    address: "Bakı, Xətai r., Nobel pr. 15",
                    clientSector: "Neft sektoru",
                    registrationDate: "05.02.2019",
                    created: "05.02.2019 10:00",
                    updated: "12.02.2023 12:45"
                },
                {
                    clientId: 5,
                    companyName: "Green Farm",
                    voen: "2009876123",
                    phone: "+994557778899",
                    email: "support@greenfarm.az",
                    address: "Gəncə, Kəpəz r., Heydər Əliyev pr. 78",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "20.09.2021",
                    created: "20.09.2021 11:11",
                    updated: "15.12.2022 09:30"
                },
                {
                    clientId: 6,
                    companyName: "Smart Solutions",
                    voen: "2014456789",
                    phone: "+994704444555",
                    email: "info@smartsol.az",
                    address: "Bakı, Binəqədi r., Azadlıq pr. 99",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "11.11.2020",
                    created: "11.11.2020 13:00",
                    updated: "22.03.2023 17:50"
                },
                {
                    clientId: 7,
                    companyName: "EuroTrans",
                    voen: "2025567891",
                    phone: "+994555667788",
                    email: "info@eurotrans.az",
                    address: "Bakı, Sabunçu r., Bakıxanov qəs.",
                    clientSector: "Müəyyən edilməmiş",
                    registrationDate: "10.06.2018",
                    created: "10.06.2018 08:45",
                    updated: "17.01.2024 14:10"
                },
                {
                    clientId: 8,
                    companyName: "Global Trade",
                    voen: "2016678902",
                    phone: "+994503456789",
                    email: "sales@globaltrade.az",
                    address: "Şəki, M.Ə.Rəsulzadə küç. 22",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "07.07.2022",
                    created: "07.07.2022 15:20",
                    updated: "01.05.2023 11:05"
                },
                {
                    clientId: 9,
                    companyName: "Caspel IT",
                    voen: "2017789012",
                    phone: "+994703456123",
                    email: "info@caspelit.az",
                    address: "Bakı, Nizami r., Qara Qarayev pr. 210",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "18.04.2019",
                    created: "18.04.2019 10:10",
                    updated: "20.02.2024 16:30"
                },
                {
                    clientId: 10,
                    companyName: "North Construction",
                    voen: "2028890123",
                    phone: "+994509876543",
                    email: "contact@northcon.az",
                    address: "Mingəçevir, Azadlıq küç. 56",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "29.08.2021",
                    created: "29.08.2021 09:00",
                    updated: "13.09.2023 13:15"
                },
                {
                    clientId: 11,
                    companyName: "OilTech Service",
                    voen: "2019901234",
                    phone: "+994558899776",
                    email: "service@oiltech.az",
                    address: "Bakı, Qaradağ r., Səngəçal terminalı",
                    clientSector: "Neft sektoru",
                    registrationDate: "02.02.2020",
                    created: "02.02.2020 12:30",
                    updated: "14.06.2023 19:20"
                },
                {
                    clientId: 12,
                    companyName: "AzTour Travel",
                    voen: "2030012345",
                    phone: "+994704567890",
                    email: "info@aztour.az",
                    address: "Bakı, İçərişəhər, Qoşa Qala qapısı 4",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "22.03.2018",
                    created: "22.03.2018 08:00",
                    updated: "25.07.2023 20:10"
                },
                {
                    clientId: 13,
                    companyName: "MegaMart",
                    voen: "2031123456",
                    phone: "+994503123456",
                    email: "contact@megamart.az",
                    address: "Bakı, Xətai r., MegaMall",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "09.09.2019",
                    created: "09.09.2019 15:45",
                    updated: "11.01.2024 12:25"
                },
                {
                    clientId: 14,
                    companyName: "AgroLife",
                    voen: "2032234567",
                    phone: "+994552233445",
                    email: "info@agrolife.az",
                    address: "Lənkəran, Heydər Əliyev pr. 17",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "30.12.2021",
                    created: "30.12.2021 10:20",
                    updated: "18.08.2023 14:00"
                },
                {
                    clientId: 15,
                    companyName: "MedStar Clinic",
                    voen: "2033345678",
                    phone: "+994706667788",
                    email: "clinic@medstar.az",
                    address: "Bakı, Səbail r., Badamdar qəs.",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "17.05.2020",
                    created: "17.05.2020 09:10",
                    updated: "22.10.2023 15:30"
                },
                {
                    clientId: 16,
                    companyName: "NextGen Telecom",
                    voen: "2034456789",
                    phone: "+994704444222",
                    email: "support@nextgen.az",
                    address: "Bakı, Nərimanov r., Ağa Neymatulla küç. 12",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "14.07.2022",
                    created: "14.07.2022 16:20",
                    updated: "06.11.2023 11:40"
                },
                {
                    clientId: 17,
                    companyName: "BlackSea Oil",
                    voen: "2035567890",
                    phone: "+994505551111",
                    email: "info@blacksea-oil.az",
                    address: "Bakı, Qaradağ r., Lokbatan",
                    clientSector: "Neft sektoru",
                    registrationDate: "08.04.2017",
                    created: "08.04.2017 07:30",
                    updated: "09.01.2024 18:00"
                },
                {
                    clientId: 18,
                    companyName: "Vision Media",
                    voen: "2036678901",
                    phone: "+994703212121",
                    email: "office@visionmedia.az",
                    address: "Bakı, Yasamal r., Elmlər m/s",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "19.10.2019",
                    created: "19.10.2019 13:15",
                    updated: "05.05.2023 09:45"
                },
                {
                    clientId: 19,
                    companyName: "Azeri Steel",
                    voen: "2037789012",
                    phone: "+994558811223",
                    email: "sales@azeristeel.az",
                    address: "Sumqayıt, Sənaye zonası",
                    clientSector: "Qeyri-neft sektoru",
                    registrationDate: "04.06.2021",
                    created: "04.06.2021 10:50",
                    updated: "02.09.2023 17:35"
                },
                {
                    clientId: 20,
                    companyName: "Caucasus Bank",
                    voen: "2038890123",
                    phone: "+994504567321",
                    email: "info@caucasusbank.az",
                    address: "Bakı, Səbail r., Neftçilər pr. 101",
                    clientSector: "Müəyyən edilməmiş",
                    registrationDate: "15.01.2016",
                    created: "15.01.2016 09:00",
                    updated: "12.12.2023 12:00"
                }
            ],
            dialogVis: false,
            status: -1,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewQuota() {
            window.open(window.location.origin + '/documents/quota', "_blank");
        },
    },
    mounted() {
        this.data.map(client => {
            const randomPin = Math.floor(1000 + Math.random() * 9000); // 4-значный PIN
            return { ...client, pin: randomPin };
        });
    }
}
</script>